import React from 'react';
import {connect} from 'react-redux';
import ReaderDashBoard from './ReaderDashBoard';
import TeacherDashBoard from './TeacherDashBoard';
import ParentDashBoard from './ParentDashBoard';

class DashBoard extends React.Component {
  render() {
    const {
      user: {role, activeSchool},
    } = this.props;
    switch (role) {
      case 'reader':
        return <ReaderDashBoard school={activeSchool} />;
      case 'teacher':
      case 'school_coordinator':
        return <TeacherDashBoard />;
      case 'parent':
        return <ParentDashBoard />;
      default:
        return <h3>Kluwell app is currently still in development. We are working hard, so check back shortly!</h3>;
    }
  }
}

export default connect(
  ({account}) => ({
    user: account.get('user').toJS(),
  }),
  null,
)(DashBoard);
